import { GbBankData } from './gb/gb-bank-data';
import { CountryBankData } from './country-bank-data';
import { DefaultCountryBankData } from './default-country-bank-data';

/**
 * @param country The country
 * @param data The data for this country
 *
 * @returns
 * A new instance of `CountryBankData` for the given `country`.
 */
export const CountryBankDataFactory = (country, data): CountryBankData => {
  switch (country) {
    case 'GB':
      return new GbBankData(country, data);
    default:
      return new DefaultCountryBankData(country, data);
  }
};
